import { render, staticRenderFns } from "./GThumbnail.vue?vue&type=template&id=53fc0e05&"
import script from "./GThumbnail.vue?vue&type=script&lang=js&"
export * from "./GThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./GThumbnail.vue?vue&type=style&index=0&id=53fc0e05&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports